import { useEffect } from "react";
import { culture } from "../../constants/common-constants";

let currentUtteranceIndex = 0;
let utteranceChunks = [];

const stopSpeaking = () => {
  window.speechSynthesis.cancel();
  currentUtteranceIndex = 0;
  utteranceChunks = [];
};

const isReaderEnabled = () => {
  try {
    const settings = JSON.parse(
      localStorage.getItem("easy-vision-user-settings") || "{}",
    )?.settings;
    return settings?.read === 1;
  } catch {
    return false;
  }
};

const speak = (text) => {
  if (!text || window.speechSynthesis.speaking) return;

  stopSpeaking(); // Clear any previous state

  // Split text into sentences or ~200 character chunks
  const splitTextSmart = (text) => {
    const pattern =
      /(?<!\b(?:Mr|Mrs|Ms|Dr|St|Sr|Jr|vs|i\.e|e\.g|etc|Prof|Inc|Ltd|Co)\.)(?<!\b[A-Z])(?<!\b[A-Z]\.)(?<!\d)\.(\s+)(?=[A-Z])/g;

    const marked = text.replace(pattern, ".|SPLIT|");
    return marked
      .split("|SPLIT|")
      .map((chunk) => chunk.trim())
      .filter(Boolean);
  };

  utteranceChunks = splitTextSmart(text);
  currentUtteranceIndex = 0;

  const speakNext = () => {
    if (currentUtteranceIndex >= utteranceChunks.length) return;

    const chunk = utteranceChunks[currentUtteranceIndex].trim();
    const utterance = new SpeechSynthesisUtterance(chunk);
    utterance.lang = culture;

    utterance.onend = () => {
      currentUtteranceIndex++;
      speakNext();
    };

    window.speechSynthesis.speak(utterance);
  };

  speakNext();
};

const ScreenReaderSetup = ({ shadowRoot }) => {
  useEffect(() => {
    if (!shadowRoot) return;

    const unlock = () => {
      document.removeEventListener("click", unlock);
    };
    document.addEventListener("click", unlock);

    const getSelectedText = () => {
      const selection = shadowRoot.getSelection?.() || document.getSelection();
      return selection?.toString()?.trim() || "";
    };

    const handleClick = (event) => {
      if (!isReaderEnabled()) {
        stopSpeaking();
        return;
      }

      const text = getSelectedText();

      if (text) {
        stopSpeaking();
        speak(text);
      } else {
        // Fallback to aria-label
        let label = event.target.getAttribute("aria-label");

        if (!label && event.target.closest("button")) {
          const button = event.target.closest("button");
          label =
            button.getAttribute("aria-label") || button.getAttribute("title");
        }

        if (label) {
          stopSpeaking();
          speak(label);
        } else {
          stopSpeaking();
        }
      }
    };

    const handleStorageChange = (e) => {
      if (e.key === "easy-vision-user-settings" && !isReaderEnabled()) {
        stopSpeaking();
      }
    };

    shadowRoot.addEventListener("click", handleClick);
    window.addEventListener("storage", handleStorageChange);

    return () => {
      shadowRoot.removeEventListener("click", handleClick);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [shadowRoot]);

  return null;
};

export default ScreenReaderSetup;
